export const auctionContentStyle = {
	auction: {
		display: 'flex',
		alignItems: 'center',
		gap: '12px',
		marginBottom: '12px',
		'@media (max-width: 639.98px)': {
			flexWrap: 'wrap',
		},
	},

	subtitle: {
		fontWeight: 400,
	},

	title: {
		marginRight: '12px',
	},

	dateWrapper: {
		display: 'flex',
		gap: '24px',
		marginBottom: '40px',
		'@media (max-width: 1023.98px)': {
			flexDirection: 'column',
			gap: '16px',
			marginBottom: '24px',
		},
		'@media (max-width: 639.98px)': {
			gap: '12px',
			marginBottom: '20px',
		},
	},

	date: {
		display: 'flex',
		gap: '12px',

		'& > div': {
			width: 'auto',
		},

		'@media (max-width: 639.98px)': {
			flexDirection: 'column',
			'& > div': {
				width: '100%',
			},
		},
	},

	dateMonthYear: {
		maxWidth: '100%',
		width: '249px',
		'@media (max-width: 639.98px)': {
			width: '100%',
		},
	},

	time: {
		'& > div:first-of-type': {
			maxWidth: '120px',
			width: '100%',
		},
		'@media (max-width: 639.98px)': {
			'& > div:first-of-type': {
				maxWidth: '100%',
				width: '100%',
			},
		},
	},

	mission: {
		display: 'flex',
		alignItems: 'center',
		gap: '12px',
		marginBottom: '40px',
		'@media (max-width: 639.98px)': {
			flexWrap: 'wrap',
			marginBottom: '20px',
		},
	},
};
